<template>
  <button @click="update(phoneNumberId)" class="btn btn-sm btn-primary">
    <font-awesome-icon icon="bolt"/>&nbsp;{{ $t('updateExt') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('updateExt')">
      <p v-if="formModel.client"><b>{{$t('client')}}</b>: {{formModel.client.companyName}} ({{formModel.client.domain}})</p>
      <p v-if="formModel.packageLimit"><b>{{$t('packageExtLimit')}}</b>: {{formModel.packageLimit}} </p>

      <label v-if="formModel.client && formModel.packageExts">{{$t('chooseExt')}} ({{ formModel.packageExts.length }})</label>
      <client-user-tree-select v-if="formModel.client" :client-filter="formModel.client._id" multiple field="ext"
                               attribute="packageExts" :model="formModel" :errors="formErrors" :auto-load-root-options="true"></client-user-tree-select>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary float-right" @click="updateExt"
                :disabled="!phoneNumberId || !formModel.packageExts || !formModel.packageExts.length || formModel.packageExts.length > formModel.packageLimit || !['tech', 'admin', 'owner'].includes($store.state.user.role)">
          {{ $t('updateExt') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>

import ClientUserTreeSelect from "../../components/ClientUserTreeSelect";
import CRUD from "../../mixins/CRUD";

export default {
  props: ['phoneNumberId', 'numberOfPackage'],
  mixins: [CRUD],
  components: {ClientUserTreeSelect},
  data() {
    return {
      showForm: false,
      service: '/phone-number',
    }
  },
  methods: {
    updateExt() {
      let loader = this.$loading.show();
      this.$service({
        url: this.service + '/update-ext/' + this.phoneNumberId,
        method: 'put',
        data: {packageExts: this.formModel.packageExts}
      }).then(response => {
        this.showForm = false;
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('updateExtSuccess'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('updateExtFail'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.$bus.$emit('phoneNumber');
        loader.hide();
      });
    },
  },
  i18n: {
    messages: {
      en: {
        updateExt: 'Update ext',
        numberOfPackage: 'Number of package',
        startTime: 'Start time',
        expireTime: 'Expire time',
        chooseExt: 'Choose ext',
        updateExtSuccess: "Ext updated!",
        updateExtFail: "Fail to update ext",
        packageExtLimit: 'Package ext limit'
      },
      vi: {
        updateExt: 'Cập nhật số nhánh',
        numberOfPackage: 'Số gói đã mua',
        startTime: 'Bắt đầu lúc',
        expireTime: 'Hết hạn lúc',
        chooseExt: 'Chọn số nhánh',
        updateExtSuccess: "Cập nhật thành công!",
        updateExtFail: "Cập nhật thất bại",
        packageExtLimit: 'Số lượng nhánh tối đa'
      }
    }
  }
}
</script>